import { useTheme } from '@emotion/react';
import { IconButton, Stack, Tooltip, Typography } from '@mui/material';
import React, { useRef, useState } from 'react';
import FileUploadField from '../../../../components/FileUploadField/FileUploadField';
import EditIcon from '@mui/icons-material/Edit';
import uploadFileToS3 from '../../../../utils/fileUpload';
import appapi from '../../../../api/apiClient';
import { useDispatch, useSelector } from 'react-redux';
import { setLoading } from '../../../../redux/features/appSlice';
import { showmessage } from '../../../../utils/toastr';
import { initCompanyDetails } from '../../../../redux/features/authSlice';
import FormRemarkField from '../../../../components/FormRemarkField';
import FormTextField from '../../../../components/FormTextField';
import { Form, Formik } from 'formik';
import * as yup from 'yup';
import { useTranslation } from 'react-i18next';

const validationSchema = yup.object({
  remarks: yup.string('Remarks').required(' ').min(1, 'Remarks should be atleast 3 character').max(300, 'Maximum Character Limit 300').required(' '),
});

export default function UploadDocumentsCard() {
  const theme = useTheme();
  const formRef = useRef();
  const text = theme.palette.primary.text;
  const textLight = theme.palette.primary.textLight;

  const { user } = useSelector((state) => state.auth);

  const { t } = useTranslation();

  const dispatch = useDispatch();
  const { companyDetails } = useSelector((state) => state.auth);
  const [editRemark, setEditRemark] = useState(false);

  const handleFile = async (file, certificateName) => {
    dispatch(setLoading(true));
    if (file?.path) {
      const attachment = await uploadFileToS3(file);
      uploadDocuments(certificateName, attachment, file.type);
    } else {
      uploadDocuments(certificateName, null, null);
    }
  };

  const uploadDocuments = async (certificateName, attachment, attachmentType) => {
    const payload = {
      companyId: companyDetails?._id,
      certificateName,
      attachment,
      attachmentType,
      remarks: '',
    };
    const response = await appapi.put(`/company-management/documents/upload`, payload);
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        dispatch(setLoading(false));
        dispatch(initCompanyDetails());
      } else {
        dispatch(setLoading(false));
        showmessage(data.message, 'error');
      }
    } else {
      dispatch(setLoading(false));
      showmessage(`Something Went Wrong!`, 'error', 2000);
    }
  };

  const handleUpdate = async (values) => {
    dispatch(setLoading(true));
    let payload = {
      ...values,
    };
    const response = await appapi.put(`company-management/remarks/${user?.companyId}`, payload);
    if (response.ok) {
      dispatch(setLoading(false));
      const data = response.data;
      if (data.status === '7400') {
        showmessage(data?.message);
        dispatch(initCompanyDetails());
        setEditRemark(false);
      } else {
        showmessage(data.message, 'error');
      }
    } else {
      dispatch(setLoading(false));
      showmessage(`Something Went Wrong!`, 'error', 2000);
    }
  };

  const cr = companyDetails?.documents.filter((res) => res.certificateName === 'Certificate of Registry')[0]?.attachment;
  const abs = companyDetails?.documents.filter((res) => res.certificateName === 'Audited/Non-Audited Balance sheet')[0]?.attachment;
  const ot = companyDetails?.documents.filter((res) => res.certificateName === 'Others')[0]?.attachment;


  return (
    <Stack style={{ backgroundColor: '#F2F3F580', borderRadius: '8px', padding: '16px', borderColor: '#8993AC26', borderWidth: '1px' }}>
      <Typography
        className="fs-16 ff-Roboto fw-regular"
        color={text}
      >
        {t('Upload documents')}
      </Typography>
      <Typography
        className="fs-12 ff-Roboto fw-regular"
        color={textLight}
      >
        {t('Please upload required documents for KYC verification. Maximum file size 5MB')}
      </Typography>
      <Stack style={{ width: '55%' }}>
        <Stack className="mt-[16px]">
          <FileUploadField
            placeholder={t('Upload Certificate of Registry')}
            url={cr ? cr : null}
            inputId={`doc1`}
            handleFile={(files) => handleFile(files, 'Certificate of Registry')}
            showFileName={true}
            fileName={t('Certificate of registry')}
            bgColor={'#f3f4f7'}
            height={'40px'}
          />
        </Stack>

        <Stack className="mt-[16px]">
          <FileUploadField
            placeholder={t('Upload audited/non-audited Balance Sheet')}
            url={abs ? abs : null}
            inputId={`doc2`}
            handleFile={(files) => handleFile(files, 'Audited/Non-Audited Balance sheet')}
            showFileName={true}
            fileName={t('Audited/Non-Audited Balance sheet')}
            bgColor={'#f3f4f7'}
            height={'40px'}
            enableExcel={true}
          />
        </Stack>
        <Stack className="mt-[16px]">
          <FileUploadField
            placeholder={t('Other files')}
            url={ot ? ot : null}
            inputId={`doc3`}
            handleFile={(files) => handleFile(files, 'Others')}
            showFileName={true}
            fileName={t('Others')}
            bgColor={'#f3f4f7'}
            height={'40px'}
          />
        </Stack>
      </Stack>
      <Stack
        style={{ backgroundColor: '#8993AC26', width: '100%', height: '1px' }}
        className="!my-[10px]"
      />
      <Formik
        innerRef={formRef}
        enableReinitialize={true}
        initialValues={{
          remarks: companyDetails?.remarks,
        }}
        validationSchema={validationSchema}
        // onSubmit={(values) => createPassword(values)}
      >
        {({ handleSubmit, values, handleChange, errors, touched, handleBlur, isValid, dirty, setFieldValue }) => (
          <Form
            noValidate
            autoComplete="off"
            className='flex flex-col'
          >
            <Stack
              direction={'row'}
              alignItems={'center'}
              justifyContent={'space-between'}
            >
              <Stack
                direction={'row'}
                alignItems={'center'}
              >
                <Typography
                  className="fs-12 ff-Roboto fw-medium"
                  color={'#003399'}
                >
                  {t('Remarks')}
                </Typography>
                <Stack
                  style={{ backgroundColor: '#8993AC26', height: '50px', width: '3px' }}
                  className="mx-[10px]"
                ></Stack>
              </Stack>

              {editRemark ? (
                <>
                  <Stack style={{ width: '80%', marginTop: '20px' }}>
                    <FormRemarkField
                      outlineLabel= {t('Remarks')}
                      name="remarks"
                      sx={{ width: '100%' }}
                      visibility={true}
                      inputProps={{ maxLength: 301 }}
                      onCancel={() => {
                        setEditRemark(false);
                        setFieldValue('remarks',companyDetails?.remarks)
                        
                      }}
                      onDone={() => handleUpdate(values)}
                      disableDone={!(isValid && dirty)}
                    />
                  </Stack>
                </>
              ) : (
                <Stack flex={1} >
                  <Typography
                  className="fs-16 ff-Roboto fw-regular"
                  color={text}
                >
                  {companyDetails?.remarks}
                </Typography>
                </Stack>
              )}
              {!editRemark && (
                <Tooltip
                  title={t('Edit Remark')}
                  placement="top"
                >
                  <IconButton
                    onClick={() => {
                      {
                        setEditRemark(true);
                      }
                    }}
                  >
                    <EditIcon style={{ transform: 'scale(1.143)', color: textLight, width: '14px', height: '14px' }} />
                  </IconButton>
                </Tooltip>
              )}
            </Stack>
          </Form>
        )}
      </Formik>
    </Stack>
  );
}
